"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionsListContextProvider = exports.useOptionsList = void 0;

var _react = require("react");

var noop = function noop() {};

var defaultCtxValue = {
  name: '',
  selectedIds: [],
  setInputMethod: noop,
  toggleItemSelection: noop,
  updateActiveId: noop
};
var OptionsListContext = (0, _react.createContext)(defaultCtxValue);
var OptionsListContextProvider = OptionsListContext.Provider;
exports.OptionsListContextProvider = OptionsListContextProvider;

var useOptionsList = function useOptionsList() {
  return (0, _react.useContext)(OptionsListContext);
};

exports.useOptionsList = useOptionsList;